import axios from "axios";
const api = axios.create({
  // baseURL: "https://api.kuang-bo.com",
  baseURL: "http://192.168.0.31:8082",
  timeout: 10000000,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Content
 * |_ News
 * |  |_ getAll
 * |  |_ 
 * |  |_ getOneCompany
 * |  |_ getMonths
 */

export const getNewsAll = async (req) => {
  return await api
    .post("/news/all", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};